import { standardApiHandler } from "../../core/core-api/apiTools";
import { getFeatureCountAdapter } from "./getFeatureCount.adapter";
import { WfsServiceServiceParams } from "../../api/api-packages/wfs-service/wfsService.service";

export type GetFeatureCountServiceParams = WfsServiceServiceParams;
export type GetFeatureCountServiceResponse = number;

export type GetFeatureCountService = (params: GetFeatureCountServiceParams) => Promise<GetFeatureCountServiceResponse>;
export const getFeatureCountService: GetFeatureCountService = standardApiHandler(getFeatureCountAdapter);
